<template>
  <b-modal size="md" hide-footer v-model="show" :title="`Edição da Configuração`" @hidden="cancelar">
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-col cols="12">
        <LgFinderPageEmpresa v-model="form.empresa"  id="finderEmpresa"
          label="Empresa Responsável:" invalidFeedback="A empresa deve ser informada!"
           @input="empresaSelect" />
      </b-col>
      <b-form-row class="d-flex justify-content-center mt-3">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue";

export default {
  name: "EmpresaResponsavelSistemaModal",
  components: {
    LgFinderPageEmpresa,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        empresa: null,
      },
    };
  },
  methods: {
    empresaSelect(empresa) {
      this.form.empresa = empresa;
    },
    async salvar() {
      if (!this.form.empresa) {
        this.$bvToast.toast("Selecione uma Empresa", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const payload = {
        id: this.configuracao.id,
        valorPropriedade: this.form.empresa.id.toString(),
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {

      if (this.configuracao.valorPropriedade) {

        this.form.empresa = {
          id: parseInt(this.configuracao.valorPropriedade),
          razaoSocial: this.configuracao.valorPropriedadeLabel,
        };
      }
    },
  },
  beforeMount() {

    this.carregarDadosIniciais();
  },
};
</script>
